import ReactPlayer from 'react-player'

export default ReactPlayer
